<div class="auth-status-page">
  <div class="auth-status-brand" aria-label="Roots by EarthScout">
    <img src="assets/images/earthscoutIcon.PNG" alt="" width="40" height="40"><span>ROOTS</span>
  </div>
  <section class="auth-status-card recovery-card" aria-labelledby="recovery-title">
    <div class="auth-status-indicator" aria-hidden="true"><mat-icon>{{ reason === 'session' ? 'lock_outline' : 'info_outline' }}</mat-icon></div>
    <div class="auth-status-eyebrow">Let’s get you back</div>
    <h1 id="recovery-title">{{ reason === 'session' ? 'Please sign in again' : 'We couldn’t open this page' }}</h1>
    @switch (reason) {
      @case ('session') { <p>Your session is no longer available. Sign in again to continue using Roots.</p> }
      @case ('profile') { <p>We couldn’t confirm your Roots profile yet. Retry the page, or sign in again to refresh your session.</p> }
      @default { <p>Your current account doesn’t have permission to open this page. Sign in with another account or contact your Roots administrator.</p> }
    }
    <div class="recovery-actions">
      <button mat-flat-button class="recovery-primary" (click)="signIn()"><mat-icon>login</mat-icon>Sign in again</button>
      <button mat-stroked-button (click)="retry()"><mat-icon>refresh</mat-icon>Retry page</button>
    </div>
    <p class="recovery-help">If the problem continues, contact your Roots administrator.</p>
  </section>
  <p class="auth-status-footer">An EarthScout Smart platform</p>
</div>
